import React, {Component} from "react";

export class ClaimStepsLayout extends Component {
    render() {
        const {children, style, className} = this.props

        return (
            <div className={className ?? "member-main-container"} style={{...style, background: 'white', paddingBottom: 470}}>
                {children}
            </div>
        )
    }
}